<template>
    <div class="nopads pb-3">
        <form
            @submit.prevent="fetchHarjaNotifications"
            @reset="onReset"
        >
            <div class="row">
                <div class="col-sm-6">
                    <span class="search-title">{{ $t('delivery_note.date') }} - {{ $t('trip_list.road_sec_from') }}</span>
                    <date-time-picker
                        v-model:date="startDate"
                        class="routa-input"
                    />
                </div>
                <div class="col-sm-6">
                    <span class="search-title">{{ $t('delivery_note.date') }} - {{ $t('trip_list.road_sec_to') }}</span>
                    <date-time-picker
                        v-model:date="endDate"
                        class="routa-input"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <span class="form-check-label">{{ $t('harja.status') }}</span>
                    <select
                        v-model="state"
                        class="form-control form-select form-select-sm"
                    >
                        <option
                            v-for="opt in stateOptions"
                            :key="opt.value"
                            :value="opt.value"
                        >
                            {{ $t(opt.label) }}
                        </option>
                    </select>
                </div>
                <div class="col-sm-6">
                    <span class="form-check-label">{{ $t('harja.notification_type') }}</span>
                    <select
                        v-model="messageType"
                        class="form-control form-select form-select-sm"
                    >
                        <option
                            v-for="opt in messageTypeOptions"
                            :key="opt.value"
                            :value="opt.value"
                        >
                            {{ $t(opt.label) }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="col-sm-12 button-container">
                <button
                    type="reset"
                    class="btn btn-danger form-button"
                >
                    {{ $t('ins_report.clear') }}
                </button>
                <button
                    type="submit"
                    class="btn btn-primary form-button"
                >
                    {{ $t('ins_report.search') }}
                </button>
            </div>
        </form>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>

import {mapHelper} from "@/components/mixins/MapMixin";
import {restApi} from "@/components/mixins/RestApiMixin";
import {timeUtils} from "@/components/mixins/TimeUtils";
import DateTimePicker from "@/components/common/DateTimePicker";

export default {
    name: 'HarjaSearch',
    components: { DateTimePicker },
    mixins: [mapHelper,restApi, timeUtils],
    props: {
        contractId: {
            type: String,
            default: null
        },
    },
    data() {
        return {
            loading: false,
            startDate: null,
            endDate: null,
            startParam: null,
            endParam: null,
            state: '',
            messageType: '',
            stateOptions: [
                { value: '', label: this.$t("harja.all") },
                { value: 'lopetettu', label: this.$t("harja.closed") },
                { value: 'vastaanotettu', label: this.$t("harja.received") },
                { value: 'kuittaamaton', label: this.$t("harja.unacknowledged") }
            ],
            messageTypeOptions: [
                { value: '', label: this.$t("harja.all") },
                { value: 'tiedoitus', label: this.$t("harja.notification") },
                { value: 'toimenpidepyynto', label: this.$t("harja.action_request") }
            ]
        }
    },
    watch: {
        endDate() {
            const dateStr = this.endDate.slice(0, 10)
            this.endParam = dateStr + 'T23:59:59+03'
        },
        startDate() {
            const dateStr = this.startDate.slice(0, 10)
            this.startParam = dateStr + 'T00:00:00+03'
        },
    },
    mounted() {
        this.startDate = this.getMonthStart()
        this.endDate = this.getToday()
    },
    methods: {
        onReset: function () {
            this.startDate = this.getMonthStart()
            this.endDate = this.getEndOfTheDay(new Date())
            this.$forceUpdate();
        },

        async fetchHarjaNotifications() {
            let params = {}
            params.start_date = this.startParam
            params.end_date = this.endParam
            params.messageType = this.messageType
            params.status = this.status

            if (this.contractId) {
                params.contract = this.contractId
            }
            try {
                this.loading = true
                this.restFetchParams(this.harjaAlertUrl, params, this.fetchSuccess, this.fetchFailed);
            } catch (e) {
                return null
            }
        },
        close: function () {
            this.$emit('close')
        },
        fetchSuccess: function (data) {
            this.loading = false
            this.$emit('search', data.data)
        },
        fetchFailed: function () {
            this.loading = false
        },
    }
}
</script>

<style scoped>

</style>
